import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetRegisterAttachmentsResponse } from "./type";

async function getRegisterAttachmentsById(
  registerId: string,
  query: GetQueries,
): Promise<GetRegisterAttachmentsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.registers.getAttachments(registerId);
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetRegisterAttachmentsResponse>(url);

  return response.data;
}

export function useGetRegisterAttachments(
  registerId: string,
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-register-attachments-${registerId}`, JSON.stringify(query ?? {})],
    () => getRegisterAttachmentsById(registerId, query ?? {}),
    mergedOptions,
  );
}
